export const DEFAULT_ADMIN_BE_GRAPHQL_ENDPOINT =
  'https://testing-api.onesimplicity.com/adminbe/graphql';
export const ENDPOINT_NAME = 'admin-be';
export const PROBLEMS_PAGE_SIZE = 10;
